"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backofficeDemo_en_us = void 0;
function backofficeDemo_en_us() {
    return {
        "backoffice.demo.errors.alreadyregisteredemail": "This email address is already registered. Please login and create an new project instead. While doing so, you can still select a demo project if you want to."
    };
}
exports.backofficeDemo_en_us = backofficeDemo_en_us;
